import { render, staticRenderFns } from "./CountPills.vue?vue&type=template&id=32f74e6c&scoped=true&"
import script from "./CountPills.vue?vue&type=script&lang=js&"
export * from "./CountPills.vue?vue&type=script&lang=js&"
import style0 from "./CountPills.vue?vue&type=style&index=0&id=32f74e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f74e6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
